import { RootState } from '@/core/store/store'
import { createSelector } from '@reduxjs/toolkit'

const wallets = (state: RootState) => state.walletReducer
export const walletsSelector = createSelector(
  wallets,
  walletReducer => walletReducer.wallets,
)

const wallet = (state: RootState) => state.walletReducer
export const walletSelector = createSelector(
  wallet,
  walletReducer => walletReducer.wallet,
)

const receive = (state: RootState) => state.walletReducer
export const receiveSelector = createSelector(
  receive,
  walletReducer => walletReducer.receive,
)

const transactions = (state: RootState) => state.walletReducer
export const walletTransactionsSelector = createSelector(
  transactions,
  walletReducer => walletReducer.transactions,
)

const withdrawal = (state: RootState) => state.walletReducer
export const withdrawalSelector = createSelector(
  withdrawal,
  walletReducer => walletReducer.withdrawal,
)

const chats = (state: RootState) => state.walletReducer
export const chatsSelector = createSelector(
  chats,
  walletReducer => walletReducer.chats,
)
